import { FolderDocumentsType } from '@/util/types';

type TFunction = (key: string, params?: Record<string, unknown>) => string;

export const generateToastMessage = (
  t: TFunction,
  operation: string,
  isMultiple: boolean,
  translatedFolderName: string,
  filesToUpdate: Omit<FolderDocumentsType, 'checked'>[],
) => {
  const operationKey = `folders.${
    operation === 'copy'
      ? isMultiple
        ? 'copying-files'
        : 'copying-file'
      : isMultiple
        ? 'moving-files'
        : 'moving-file'
  }`;

  const resultKey = `folders.${
    operation === 'copy'
      ? isMultiple
        ? 'files-copied'
        : 'file-copied'
      : isMultiple
        ? 'files-moved'
        : 'file-moved'
  }`;

  const operationText = t(operationKey, {
    folder: translatedFolderName,
    name: isMultiple ? '' : filesToUpdate[0].name,
  });

  const resultText = t(resultKey, {
    isMultiple,
    folder: translatedFolderName,
    filename: '',
  });

  return `${operationText}\n${resultText}`;
};
